import React from "react";

import { SingleBehindTheScenes } from "data/videoProductPage";

import * as styles from "./BehindTheScenes.css";
import { SingleBehindTheScene } from "./SingleBehindTheScene";

export const BehindTheScenesSection = ({
  behindTheScenes,
}: {
  behindTheScenes: SingleBehindTheScenes[];
}) => {
  return (
    <section className={styles.BehindTheScenesSection}>
      <div className={styles.BehindTheScenesTitle}>A better kind of online class</div>
      <div className={styles.BehindTheScenesList}>
        {behindTheScenes?.map((item: SingleBehindTheScenes, i: number) => (
          <SingleBehindTheScene key={i} behindTheScene={item} />
        ))}
      </div>
    </section>
  );
};
